const BREADCRUMB_ROUTE_PATTERNS = [
  /^\/seasons\/?$/,
  /^\/season\/[^/]+(?:\/draft)?\/?$/,
  /^\/franchises\/?$/,
  /^\/franchise\/[^/]+\/?$/,
  /^\/franchise\/[^/]+\/season\/[^/]+(?:\/wrapped)?\/?$/,
];

export const shouldShowContextBreadcrumb = (pathname: string) =>
  BREADCRUMB_ROUTE_PATTERNS.some((pattern) => pattern.test(pathname));
